import { render, staticRenderFns } from "./AllocateLeads.vue?vue&type=template&id=9078bbce&"
import script from "./AllocateLeads.vue?vue&type=script&lang=js&"
export * from "./AllocateLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports